import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {ArticleDto} from "../article.dto";

export class SearchArticleRes extends SearchResultDto {

  public override readonly items: SearchArticleItem[] = [];

  constructor(init?: Partial<SearchArticleRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchArticleItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchArticleItem extends ArticleDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchArticleItem>) {
    super(init);
    Object.assign(this, init);
  }
}
